import React, {FunctionComponent, Suspense, useEffect, useState, useRef} from 'react';
import { Link, useHistory } from 'react-router-dom';
import logo from 'assets/images/social_play_logo_horizontal.png';
import subscriptionIcon from 'assets/svg/superhost-subscription.svg';
import hostInfographicImage from 'assets/images/host-infographic.png';
import dashboardIcon from 'assets/svg/dashboard.svg';
import userIcon from 'assets/svg/user_blue.svg';
import settingIcon from 'assets/svg/settings_1.svg';
import logoutIcon from 'assets/svg/logout.svg';
import helpIcon from 'assets/svg/chat-info.svg'
import Button from 'components/button/Button';
import Styles from 'components/header/Header.module.scss';
import CustomModal from 'components/customModal/CustomModal';
import InputField from 'components/textField/InputField';
import TextErrorMessage from 'components/utils/errorMessage/TextErrorMessage';
import { IMAGE_URL } from 'store/services/URL';
import { callLogout } from 'store/actions/auth.actions';
import { createRoom as createRoomActions } from 'store/actions/conversation.actions';
import { useDispatch } from 'react-redux';
import { getCurrentDate } from 'helpers/utils';
import { createRoom as roomCreate } from 'store/services/firebase-broadcast';
import { ref, onValue } from 'firebase/database';
import { db } from 'utils/firebase-config';
import { CardList, Subscription } from 'modules/types/types';
import getItemFromLocalStorage from 'utils/getItemFromLocalStorage';
import LocationStatus from 'components/locationPermission/LocationStatus';
const Stripe = React.lazy(() => import('views/Stripe/Stripe'));

interface HeaderProps {
  getSubscriptionRequest: Function;
  createRoomRequest: Function;
  showPopup?: boolean;
  isLoading: boolean;
  status: boolean;
  createdRoom: any;
  subscriptions: Subscription;
  card: CardList;
  callStatus?: Function;
}
const Header: FunctionComponent<HeaderProps> = (props: HeaderProps) => {
  const { getSubscriptionRequest, createRoomRequest, isLoading, showPopup, createdRoom, subscriptions, card, callStatus, status: isRoomCreated } = props;
  const history = useHistory();
  const [topic, setTopic] = useState('');
  const [showDropDown, setShowDropdown] = useState(false);
  const [createRoom, setCreateRoom] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [createdRoomTitle, setCreatedRoomTitle] = useState('');
  const processedRoomRef = useRef(null);
  const isMountedRef = useRef(true);
  const subscriptionTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [limit, setLimit] = useState<any>(28);
  const [length, setLength] = useState<any>(0);
  const [error, setError] = useState(false);
  const [paymentPopUp, setPaymentPopUp] = useState(false);
  const [moveCallScreen, setMoveCallScreen] = useState<boolean>(false);
  const [conversations, setConversations] = useState<any>([]);
  const [user, setUser] = useState<any>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const dispatch = useDispatch();

  const handleChange = (event: any) => {
    setTopic(event);
    if (length > event.length) {
      setLimit(limit + 1);
      setLength(event.length);
    } else {
      setLimit(limit - 1);
      setLength(length);
    }
  };

  const handleRoomCreationSuccess = (room: any) => {
    if (room && room.hasOwnProperty('pk') && room.pk !== processedRoomRef.current) {
      setCreatedRoomTitle(room.topic || '');
      setShowSuccessModal(true);
      processedRoomRef.current = room.pk;
      
      // Reset the isRoomCreated flag to prevent re-triggering
      dispatch(createRoomActions.pending);
    }
  };

  const handleNext = () => {
    if (topic.length > 0 && user) {
      createRoomRequest({
        topic
      });
      setCreateRoom(false);
    } else {
      setError(true);
    }
  };

  useEffect(() => {
    if (isRoomCreated && createdRoom.hasOwnProperty('pk')) {
      handleRoomCreationSuccess(createdRoom);
    }
  }, [isRoomCreated, createdRoom]);

  useEffect(() => {
    // Fetch subscription data when component mounts
    getSubscriptionRequest({});
  }, [getSubscriptionRequest]);

  // Cleanup effect to handle component unmounting
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
      if (subscriptionTimeoutRef.current) {
        clearTimeout(subscriptionTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const roomsRef = ref(db, `rooms`);
    
    const unsubscribe = onValue(roomsRef, (querySnapshot: any) => {
      const rooms: any = [];
      querySnapshot.forEach((doc: any) => {
        rooms.push(doc.val());
      });
      setConversations(rooms);
    });

    // Cleanup function to unsubscribe when component unmounts
    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (user?.is_super_host && moveCallScreen && conversations.length > 0) {
      history.push({pathname: '/chat-room', state: {conversations: conversations}});
      // history.push({ pathname: '/call', state: { selectedBroadCast: createdRoom}});
    }
  }, [moveCallScreen, user, conversations, history]);

  useEffect(() => {}, [isLoading]);

  useEffect(() => {
    setCreateRoom(showPopup || createRoom);
  }, [showPopup]);

  const handleCreateRoom = () => {
    document.body.classList.add('modal-open');
    return (
      <>
        <p className="fontSixteen font-weight-600 text-black">Enter your topic for this room</p>
        <p>
          Character limit:
          <strong> 28</strong>
        </p>
        <InputField placeholder="Topic" type="text" handleChange={(e: any) => handleChange(e)} />
        <Button label="Next" cssClass={`${Styles.nextBtn} ${error && 'errorButton'}`} showLoading={isLoading} clickHandler={handleNext} icon />
        {error && <TextErrorMessage cssClass="text-center" message="Enter a topic to continue." />}
        <div
          className="text-uppercase text-blue font-weight-600 mt-3"
          onClick={closeDialog}
          onKeyPress={closeDialog}
          role="button"
          tabIndex={0}
        >
          Close
        </div>
      </>
    );
  };

  const handleSubscribeSuperHost = () => {
    setSubscribed(false);
    setPaymentPopUp(true);
  };

  const stripePaymentModal = () => {
    document.body.classList.add('modal-open');
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <Stripe type="subscribe" planId='' card={card} subscription={subscriptions} closeDialog={paymentDone} />
      </Suspense>
    );
  };

  const handleSubscribed = () => (<div className="text-center">
      <img src={subscriptionIcon} alt="subscription super host" className={Styles.superHostImage} />
      <h4 className="mt-4 font-weight-600">Subscribe to be a Super Host!</h4>
      <p className="mt-30 mb-0">
        To join a room with more than 3 people will cost your guest a gold piece. A premium super host subscription will
        wave all of the fees for your guests.
      </p>
      <Button label="Subscribe" cssClass={Styles.subscribeBtn} clickHandler={handleSubscribeSuperHost} />
      <div
        className="text-uppercase text-blue font-weight-600 mt-3"
        onClick={handleSkip}
        onKeyPress={handleSkip}
        role="button"
        tabIndex={0}
      >
        Skip
      </div>
    </div>);

  const handleRoomCreatedSuccess = () => (
    <div className="text-center">
      <h4 className="mt-4 font-weight-600">Your room "{createdRoomTitle}" has been created successfully!</h4>
      <p className="mt-3 mb-0">
        You're the host. Remember to accept join requests, post regularly and invite your friends all from the room control panel.
      </p>
      <img src={hostInfographicImage} alt="Host Controls" className={Styles.hostInfographic} />
      <Button label="Okay" cssClass={Styles.successModalButton} clickHandler={closeSuccessModal} />
    </div>
  );

  const paymentDone = () => {
    document.body.classList.remove('modal-open');
    setCreateRoom(false);
    setSubscribed(false);
    setPaymentPopUp(false);
    history.push({pathname: '/chat-room', state: {conversations: conversations, selected: createdRoom}});
  };

  const handleSubscriptionClose = () => {
    setSubscribed(false);
    history.push({pathname: '/chat-room', state: {conversations: conversations, selected: createdRoom}});
  };

  const handleSkip = () => {
    document.body.classList.remove('modal-open');
    setCreateRoom(false);
    setSubscribed(false);
    setPaymentPopUp(false);
    history.push({pathname: '/chat-room', state: {conversations: conversations, selected: createdRoom}});
  };

  const closeSuccessModal = () => {
    setShowSuccessModal(false);
    setCreatedRoomTitle('');
    
    // Show subscription modal if user is not a super host, otherwise navigate directly
    if (user && !user.is_super_host) {
      setSubscribed(true);
    } else {
      history.push({pathname: '/chat-room', state: {conversations: conversations, selected: createdRoom}});
    }
  };

  const closeDialog = () => {
    document.body.classList.remove('modal-open');
    setCreateRoom(false);
    setSubscribed(false);
    setPaymentPopUp(false);
    setError(false);
  };

  const handleDropDown = () => {
    setShowDropdown(!showDropDown);
  };

  const handleBgDropDown = () => {
    setShowDropdown(!showDropDown);
  };

  const showPublicProfile = () => {
    history.push('/profile');
  };

  const handleLogOut = () => {
    dispatch(callLogout());
    history.push('/login');
  };

  useEffect(() => {
    if (topic.length > 0) {
      setError(false);
    }
  }, [topic.length])

  useEffect(() => {}, [card]);

  useEffect(() => {
    getSubscriptionRequest({});
  }, []);

  // Enhanced authentication handling
  useEffect(() => {
    const checkAuth = () => {
      const userData = getItemFromLocalStorage('user');
      if (userData && userData.access && userData.pk && userData.name) {
        setUser(userData);
        setIsAuthenticated(true);
      } else {
        setUser(null);
        setIsAuthenticated(false);
        // Redirect to login if no valid user
        history.push('/login');
      }
    };

    checkAuth();

    // Listen for token expiration events
    const handleTokenExpired = () => {
      console.log('Token expired event received in Header');
      setUser(null);
      setIsAuthenticated(false);
      history.push('/login');
    };

    const handleAuthRequired = () => {
      console.log('Auth required event received in Header');
      setUser(null);
      setIsAuthenticated(false);
      history.push('/login');
    };

    window.addEventListener('tokenExpired', handleTokenExpired);
    window.addEventListener('authRequired', handleAuthRequired);
    
    return () => {
      window.removeEventListener('tokenExpired', handleTokenExpired);
      window.removeEventListener('authRequired', handleAuthRequired);
    };
  }, [history]);

  // Don't render if not authenticated
  if (!isAuthenticated || !user) {
    return null;
  }

  return (
    <header>
      <div className="custom-container h-100">
        <div className={Styles.headerWrapper}>
          <Link to="/conversations-nearby" className={`d-inline-block ${Styles.logoWrapper}`}>
            <img src={logo} alt="logo" className={Styles.logo} />
          </Link>
          <div className={Styles.profileName}>
            <LocationStatus />
            <Button
              label="CREATE ROOM"
              clickHandler={() => setCreateRoom(true)}
              cssClass={Styles.createRoomWidth}
              iconClass="fas fa-plus"
              icon
            />
            <span className={Styles.divider} />
            <div
              className="d-flex column-gap-20 align-items-center position-relative"
              onClick={handleDropDown}
              role="button"
              onKeyPress={handleDropDown}
              tabIndex={0}
            >
              <div className={`d-inline-block ${Styles.profileLogoWrapper}`}>
                {user?.profile ? (
                  <img src={`${IMAGE_URL}${user.profile}`} alt="profile" className={Styles.profileIcon} />
                ) : (
                  <img src={userIcon} alt="profile" className={Styles.profileIcon} />
                )}
              </div>
              <p className={`mb-0 fontSixteen text-blue font-weight-bolder text-capitalize ${Styles.userNameWrapper}`}>
                <span>{user?.name || 'User'}</span>
                <i className="fas fa-angle-down ml-2" />
              </p>
              {showDropDown && (
                <>
                  <div className={Styles.dropDownWrapper}>
                    <ul className={`${Styles.dropDownInner} list-unstyled`}>
                      <li>
                        <Link
                          className="text-decoration-none text-black fontSixteen font-weight-normal"
                          to="/conversations-nearby"
                        >
                          <img className="pr-2" src={dashboardIcon} alt="dashboard" />
                          Home
                        </Link>
                      </li>
                      <li>
                        <div
                          className="d-flex"
                          onClick={showPublicProfile}
                          onKeyPress={showPublicProfile}
                          role="button"
                          tabIndex={0}
                        >
                          <img className="pr-2" src={userIcon} alt="user" />
                          <p className="text-decoration-none mb-0 text-black fontSixteen font-weight-normal">
                            View Public Profile
                          </p>
                        </div>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-black fontSixteen font-weight-normal"
                          to="/profile/edit"
                        >
                          <img className="pr-2" src={settingIcon} alt="settings" />
                          Settings
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-black fontSixteen font-weight-normal"
                          to="/help"
                        >
                          <img className="pr-2" src={helpIcon} alt="help" style={{width: '30px', height: '30px', marginLeft: '-3px'}} />
                          Help
                        </Link>
                      </li>
                      <li>
                        <div onClick={handleLogOut} onKeyPress={handleLogOut} role="button" tabIndex={0}>
                          <img className="pr-2" src={logoutIcon} alt="logout" />
                          Logout
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div
                    className={Styles.bgDropDown}
                    onClick={handleBgDropDown}
                    role="button"
                    onKeyPress={handleBgDropDown}
                    tabIndex={0}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {createRoom && (
        <CustomModal wrapperClass={Styles.createRoomWrapper} title="Create Room" closeDialog={closeDialog}>
          {handleCreateRoom()}
        </CustomModal>
      )}
      {showSuccessModal && (
        <CustomModal wrapperClass={Styles.successModalWrapper} closeDialog={closeSuccessModal}>
          {handleRoomCreatedSuccess()}
        </CustomModal>
      )}
      {subscribed && (
        <CustomModal wrapperClass={Styles.createRoomWrapper} closeDialog={handleSubscriptionClose}>
          {handleSubscribed()}
        </CustomModal>
      )}
      {paymentPopUp && (
        <CustomModal closeDialog={closeDialog} title="Subscribe" wrapperClass={Styles.rechargeAccountWrapper}>
          {stripePaymentModal()}
        </CustomModal>
      )}
    </header>
  );
};

export default Header;